<template>
  <section class="col-12 col-xl-12 col-md-12 box-col-12">
    <div class="card item-certification-wraper">
      <div class="card-header">{{ $t('sertifikat_pelatihan') }}</div>

      <div class="card-body">
        <ItemCertitification v-for="(item,idx) in certifications" :key="idx" :item="item"></ItemCertitification>
      </div>

      <div class="card-action">
        <button v-b-modal.certification class="btn btn-block btn-action"><i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>Add {{ $t('sertifikat_pelatihan') }}</button>
      </div>
    </div>



    <!-- Vertically centered Modal Component -->
    <b-modal
      id="certification"
      size="lg"
      width="100%"
      centered
      :title="`Add Certificate and Training`"
      ok-title="Save"
      cancel-title="Cancel"
      class="theme-modal"
      @ok="handleSubmit"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">Name</h6>
            <input
              class="form-control"
              v-model="form.nama"
              placeholder="Name"
            />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('nama_institusi') }}</h6>
            <input
              class="form-control"
              v-model="form.nama_institusi"
              :placeholder="$t('nama_institusi')"
            />
          </div>
        </div>



        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_mulai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateMulai" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_selesai') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dateEnd" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>

      </div>
    </b-modal>
  </section>
</template>

<script>
  import ItemCertitification from "./item/ItemCertitification.vue";
  import Datepicker from 'vuejs-datepicker';
  import { formatDate } from '../../_helpers';
  import { submitDataCertification,getDataCertification } from "../../_services/profile.service";

  export default {
    components: {
      ItemCertitification,
      Datepicker
    },
    data() {
      return {
        form : {
          id_user : this.$route.query.id_user,
          nama: '',
          nama_institusi : '',
          tanggal_mulai : '',
          tanggal_selesai : ''
        },
        certifications : []
      };
    },
    computed:{
      dateMulai : {
        get(){
          return this.form.tanggal_mulai;
        },
        async set(val){
          this.form.tanggal_mulai = await formatDate(val);
        },
      },
      dateEnd : {
        get(){
          return this.form.tanggal_selesai;
        },
        async set(val){
          this.form.tanggal_selesai = await formatDate(val);
        },
      }
    },
    mounted(){
      this.fetchDataCertification();
    },
    methods : {
      async fetchDataCertification(){
        this.certifications = await getDataCertification(this.$route.query.id_user);
      },
      async handleSubmit(){
        await submitDataCertification(this.form);
        this.fetchDataCertification();
      }
    }
  };
</script>

<style lang="scss">
.item-certification-wraper {
  padding: 0;
  .card-header {
    padding: 18px 25px !important;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .item {
    flex-direction: column;
    h3 {
      font-size: 0.9rem;
      font-weight: 500;
    }
    h5 {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 18px 25px !important;
    gap: 1rem;

    max-height: 360px;
    height: 360px;
    overflow: auto;
      flex-direction: column;
  }

  .item-personal {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-address {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-minat {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px 25px;
    display: flex;
    flex-direction: column;

    .item-hobie {
      flex: 1;
      h3 {
        font-size: 0.9rem;
        font-weight: 500;
      }

      .list-item {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .rounded {
          padding: 0.2rem 1rem;
          background: var(--theme-deafult);
          color: var(--theme-font);
          font-size: 0.7rem;
          border-radius: 1rem !important;
        }
      }
    }
  }

  .btn-action{
    border-top: 1px solid #E9ECEF;
    font-weight: 600;
    padding-top: .7rem;
    padding-bottom: .7rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    color: #1d1e26;
    .fa{
      font-size: 1rem;
    }
  }

  .card-body {
    display: flex;
    .d-flex {
      width: 100%;
    }
  }
}
</style>
